import { Box, styled } from "@mui/material";
import { IStyledChatRootProps } from "./types";

const StyledRoot = styled(Box)<IStyledChatRootProps>(({ theme }) => ({
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    minWidth: 0,
    position: "relative",
    overflowX: "hidden",
}));

export {StyledRoot}